exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body, html {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.App {\n  display: flex;\n  flex-flow: row wrap;\n  height: 100%;\n}\n\n.canvas-container {\n  flex: 1 1;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\ncanvas {\n  border: 1px solid black;\n}\n\n.options-menu {\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: flex-start; */\n  align-items: center;\n  align-self: center;\n}\n\n#docPicker {\n  display: none\n}", ""]);

// exports
